module.exports = __webpack_public_path__ + "static/img/Hood_Facia_Natural.a55654e.jpg";